class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const sections = this.getSectionsToRender();
    let renderedSections = parsedState.sections;

    try {
      if (!renderedSections || sections.some((section) => typeof renderedSections[section.id] !== 'string')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sections.map((section) => section.id).join(','));
        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('Cart notification sections could not be loaded');
        renderedSections = await response.json();
      }

      const updates = sections.map((section) => {
        const target = document.getElementById(section.id);
        const html = renderedSections && renderedSections[section.id];
        if (!target || typeof html !== 'string') throw new Error('Cart notification section is unavailable');
        return { target, html: this.getSectionInnerHTML(html, section.selector) };
      });

      updates.forEach((update) => {
        update.target.innerHTML = update.html;
      });
      if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
      this.open();
    } catch (error) {
      console.error(error);
      window.location.assign(window.routes.cart_url);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
